import { storybookReady } from '../../../core/js/utils'

let storybook

(async function() {
  storybook = await storybookReady()

  const displayHiddenElementContainers = document.querySelectorAll('.js-display-hidden-element-container')

  displayHiddenElementContainers.forEach(element => {
    const displayContentButton = element.querySelector('.js-display-hidden-element-button')
    const hideContentButton = element.querySelector('.js-hide-hidden-element-button')
    const hiddenElement = element.querySelector('.js-hidden-element')
    if (!displayContentButton) {
      return
    }
    displayContentButton.addEventListener('click', (event) => {
      event.preventDefault()
      if (!hiddenElement) {
        return
      }
      hiddenElement.classList.remove('hidden-element')
      hideContentButton.classList.remove('hidden-button')
      displayContentButton.classList.add('hidden-button')
    })
    hideContentButton && hideContentButton.addEventListener('click', (event) => {
      event.preventDefault()
      if (!hiddenElement) {
        return
      }
      hiddenElement.classList.add('hidden-element')
      hideContentButton.classList.add('hidden-button')
      displayContentButton.classList.remove('hidden-button')
      element.scrollIntoView({behavior: 'smooth', block: 'center'})
    })
  })
})()
